// @ts-nocheck

import SmileOutlined from '@ant-design/icons/SmileOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import LineChartOutlined from '@ant-design/icons/LineChartOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import HomeOutlined from '@ant-design/icons/HomeOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import HighlightOutlined from '@ant-design/icons/HighlightOutlined';
import UserSwitchOutlined from '@ant-design/icons/UserSwitchOutlined';
import TableOutlined from '@ant-design/icons/TableOutlined';
import ScheduleOutlined from '@ant-design/icons/ScheduleOutlined';
import SolutionOutlined from '@ant-design/icons/SolutionOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined';
import UploadOutlined from '@ant-design/icons/UploadOutlined';
import ProfileOutlined from '@ant-design/icons/ProfileOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import FileImageOutlined from '@ant-design/icons/FileImageOutlined';
import NotificationOutlined from '@ant-design/icons/NotificationOutlined';
import EditFilled from '@ant-design/icons/EditFilled';
import CopyFilled from '@ant-design/icons/CopyFilled';
import OrderedListOutlined from '@ant-design/icons/OrderedListOutlined';
import ContainerOutlined from '@ant-design/icons/ContainerOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import MoneyCollectOutlined from '@ant-design/icons/MoneyCollectOutlined';
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined'

export default {
  SmileOutlined,
UserOutlined,
LineChartOutlined,
ProjectOutlined,
BankOutlined,
HomeOutlined,
ClockCircleOutlined,
HighlightOutlined,
UserSwitchOutlined,
TableOutlined,
ScheduleOutlined,
SolutionOutlined,
TeamOutlined,
FileDoneOutlined,
UploadOutlined,
ProfileOutlined,
ShopOutlined,
FileImageOutlined,
NotificationOutlined,
EditFilled,
CopyFilled,
OrderedListOutlined,
ContainerOutlined,
DollarOutlined,
MoneyCollectOutlined,
VideoCameraOutlined,
SettingOutlined
}
    